const resource = 'newsletter_subscriptions'

export default $axios => ({
  create(params) {
    return $axios.$post(`/${resource}/guest`, params)
  },

  enable(id, params) {
    return $axios.$patch(`/${resource}/enable/${id}`, { params })
  },

  enableGuest(key) {
    return $axios.$get(`/${resource}/enable_guest/${key}`)
  },

  updatePreferences(params) {
    return $axios.$patch('/v2/account/newsletter', params)
  },

  confirmAccountSubscription() {
    return $axios.$post('/v2/account/newsletter/confirm')
  },

  confirmReconsent(token) {
    return $axios.$post('/v2/newsletter/reconsent/confirm', { token })
  },

  reconsentPreferences(token) {
    return $axios.$get('/v2/newsletter/reconsent/preferences', {
      params: { token },
    })
  },

  updateReconsentPreferences(token, language) {
    return $axios.$patch('/v2/newsletter/reconsent/preferences', {
      token,
      language,
    })
  },

  unsubscribeReconsent(token) {
    return $axios.$post('/v2/newsletter/reconsent/unsubscribe', { token })
  },

  disable(id, params) {
    return $axios.$patch(`/${resource}/disable/${id}`, { params })
  },

  getServiceName: name => 'newsletterSubService',
})
